export default "__VITE_ASSET__pjxVIGYj__"